/* ITRefurbs theme behaviour.
   Cart uses Shopify's AJAX Cart API with BUNDLED SECTION RENDERING: every cart
   mutation asks Shopify to re-render the cart sections and we swap the returned
   HTML in. The server owns the markup, so the drawer can never drift out of sync
   and works on first paint without JS. All hooks are data-* attributes. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var d = document;
  var $ = function (sel, root) { return (root || d).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); };

  /* ─── Utilities ─── */
  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function trapFocus(container, returnTo) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = $$(sel, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.__trap = onKey;
    d.addEventListener('keydown', onKey);
    container.__returnTo = returnTo || d.activeElement;
  }
  function releaseFocus(container) {
    if (container.__trap) { d.removeEventListener('keydown', container.__trap); container.__trap = null; }
    if (container.__returnTo && container.__returnTo.focus) container.__returnTo.focus();
  }
  function lockScroll(on) {
    d.documentElement.classList.toggle('itr-noscroll', !!on);
  }

  /* ─── Cart drawer ─── */
  var cartRoot = function () { return $('[data-cart-drawer]'); };

  function openCart() {
    var root = cartRoot(); if (!root) return;
    root.classList.add('is-open');
    lockScroll(true);
    var panel = $('.itr-cart__panel', root);
    if (panel) { panel.focus(); trapFocus(panel); }
  }
  function closeCart() {
    var root = cartRoot(); if (!root) return;
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    lockScroll(false);
    var panel = $('.itr-cart__panel', root);
    if (panel) releaseFocus(panel);
  }

  /* Sections we ask Shopify to re-render on every cart mutation. Ids are read
     off the rendered DOM, never hardcoded (section ids differ per template). */
  function cartSections() {
    var ids = [];
    var root = cartRoot();
    if (root && root.dataset.sectionId) ids.push(root.dataset.sectionId);
    var main = $('[data-cart-main]');
    if (main && main.dataset.sectionId) ids.push(main.dataset.sectionId);
    return ids;
  }

  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var incoming = new DOMParser().parseFromString(html, 'text/html');
      // Swap the cart drawer
      var newDrawer = incoming.querySelector('[data-cart-drawer]');
      var oldDrawer = cartRoot();
      if (newDrawer && oldDrawer) {
        var wasOpen = oldDrawer.classList.contains('is-open');
        oldDrawer.innerHTML = newDrawer.innerHTML;
        if (wasOpen) oldDrawer.classList.add('is-open');
      }
      // Swap the cart page body
      var newMain = incoming.querySelector('[data-cart-main]');
      var oldMain = $('[data-cart-main]');
      if (newMain && oldMain) oldMain.innerHTML = newMain.innerHTML;
    });
    syncCount();
  }

  function syncCount() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('.itr-cart-count').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  function cartRequest(url, body) {
    body.sections = cartSections().join(',');
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) { showCartError(data.description || data.message); return null; }
        applySections(data.sections);
        return data;
      })
      .catch(function () { window.location.href = '/cart'; return null; });
  }

  function showCartError(msg) {
    var body = $('[data-cart-body]');
    if (!body) { alert(msg); return; }
    var p = d.createElement('p');
    p.className = 'itr-cart__error';
    p.textContent = msg;
    body.insertBefore(p, body.firstChild);
    setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 4000);
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    return cartRequest('/cart/add.js', { id: id, quantity: qty || 1 }).then(function (data) {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      if (data) openCart();
    });
  }
  function changeLine(line, quantity) {
    var root = cartRoot();
    if (root) root.classList.add('is-busy');
    return cartRequest('/cart/change.js', { line: line, quantity: quantity }).then(function (r) {
      if (root) root.classList.remove('is-busy');
      return r;
    });
  }

  /* ─── Mobile nav ─── */
  function openNav() {
    var sc = $('.itr-mobnav-scrim'), dr = $('.itr-mobnav');
    if (sc) sc.classList.add('is-open');
    if (dr) { dr.classList.add('is-open'); dr.focus(); trapFocus(dr); }
    lockScroll(true);
  }
  function closeNav() {
    var sc = $('.itr-mobnav-scrim'), dr = $('.itr-mobnav');
    if (sc) sc.classList.remove('is-open');
    if (dr && dr.classList.contains('is-open')) { dr.classList.remove('is-open'); releaseFocus(dr); }
    lockScroll(false);
  }

  /* ─── Mobile search overlay ─── */
  function openSearch() {
    var s = $('[data-search-overlay]');
    if (!s) return;
    s.classList.add('is-open');
    lockScroll(true);
    var input = $('input[type="search"]', s);
    if (input) setTimeout(function () { input.focus(); }, 60);
    trapFocus(s);
  }
  function closeSearch() {
    var s = $('[data-search-overlay]');
    if (!s || !s.classList.contains('is-open')) return;
    s.classList.remove('is-open');
    lockScroll(false);
    releaseFocus(s);
  }

  /* ─── Delegated events ─── */
  d.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    if (t.closest('[data-nav-open]')) { e.preventDefault(); openNav(); return; }
    if (t.closest('[data-nav-close]')) { e.preventDefault(); closeNav(); return; }

    if (t.closest('[data-search-open]')) { e.preventDefault(); openSearch(); return; }
    if (t.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); return; }

    var mobsub = t.closest('[data-mobsub-toggle]');
    if (mobsub) {
      e.preventDefault();
      var wrap = mobsub.closest('[data-mobsub]');
      var open = wrap.classList.toggle('is-open');
      mobsub.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var qty = t.closest('[data-qty-change]');
    if (qty) {
      e.preventDefault();
      changeLine(qty.dataset.line, parseInt(qty.dataset.qtyChange, 10));
      return;
    }

    /* Plain +/- stepper (product form, not a cart line) */
    var step = t.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var box = step.closest('.itr-qty');
      var inp = box && box.querySelector('input');
      if (inp) {
        var min = parseInt(inp.min || '1', 10);
        var next = (parseInt(inp.value, 10) || min) + parseInt(step.dataset.qtyStep, 10);
        inp.value = Math.max(min, next);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var docOpen = t.closest('[data-doc-open]');
    if (docOpen) {
      var m = d.getElementById(docOpen.getAttribute('data-doc-open'));
      if (m) { m.classList.add('is-open'); lockScroll(true); trapFocus(m); }
      return;
    }
    if (t.closest('[data-doc-close]') || (t.hasAttribute && t.hasAttribute('data-doc-modal'))) {
      var mm = t.closest('[data-doc-modal]');
      if (mm) { mm.classList.remove('is-open'); lockScroll(false); releaseFocus(mm); }
      return;
    }
    if (t.closest('[data-doc-print]')) { window.print(); return; }

    /* Nav dropdowns — hover on desktop (CSS), tap to toggle on touch */
    var navBtn = t.closest('[data-nav-drop] > .itr-navbtn');
    if (navBtn) {
      var wrapN = navBtn.closest('[data-nav-drop]');
      var menu = $('.itr-navmenu', wrapN);
      if (menu && window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        var wasOpen = menu.classList.contains('is-open');
        $$('.itr-navmenu.is-open').forEach(function (x) { x.classList.remove('is-open'); });
        $$('.itr-navbtn.is-open').forEach(function (x) { x.classList.remove('is-open'); x.setAttribute('aria-expanded', 'false'); });
        if (!wasOpen) { menu.classList.add('is-open'); navBtn.classList.add('is-open'); navBtn.setAttribute('aria-expanded', 'true'); }
        return;
      }
    }
    if (!t.closest('[data-nav-drop]')) {
      $$('.itr-navmenu.is-open').forEach(function (x) { x.classList.remove('is-open'); });
      $$('.itr-navbtn.is-open').forEach(function (x) { x.classList.remove('is-open'); x.setAttribute('aria-expanded', 'false'); });
    }

    /* Product gallery thumbnails */
    var thumb = t.closest('[data-pdp-thumb]');
    if (thumb) {
      e.preventDefault();
      var main = $('[data-pdp-image]');
      if (main) { main.src = thumb.dataset.pdpThumb; main.srcset = ''; }
      $$('[data-pdp-thumb]').forEach(function (b) { b.classList.remove('is-on'); });
      thumb.classList.add('is-on');
      return;
    }

    /* Product-grid filter chips */
    var chip = t.closest('[data-chip]');
    if (chip) {
      var chips = $$('[data-chip]');
      chips.forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-pressed', 'false'); });
      chip.classList.add('is-on');
      chip.setAttribute('aria-pressed', 'true');
      var val = chip.getAttribute('data-chip');
      $$('[data-card-cat]').forEach(function (card) {
        var cat = card.getAttribute('data-card-cat') || '';
        var sale = card.getAttribute('data-card-sale') === 'true';
        var show = val === 'Sale' ? sale : cat.toLowerCase().indexOf(val.toLowerCase()) !== -1;
        card.hidden = !show;
      });
      var link = d.getElementById('itr-browse-all');
      if (link && $('span', link)) $('span', link).textContent = val === 'Sale' ? 'sale items' : val;
      return;
    }
  });

  /* Quantity typed directly (cart lines only) */
  d.addEventListener('change', debounce(function (e) {
    var input = e.target.closest ? e.target.closest('[data-qty-input]') : null;
    if (!input || !input.dataset.line) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    changeLine(input.dataset.line, v);
  }, 250));

  /* AJAX add-to-cart for any form marked data-ajax-add */
  d.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return; // let it post normally
    e.preventDefault();
    var qtyEl = form.querySelector('[name="quantity"]');
    addToCart(idEl.value, qtyEl ? parseInt(qtyEl.value, 10) : 1, form.querySelector('[type="submit"]'));
  });

  /* Escape closes every overlay */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-doc-modal].is-open').forEach(function (m) { m.classList.remove('is-open'); releaseFocus(m); });
    $$('[data-welcome-promo]:not([hidden])').forEach(function (p) {
      p.hidden = true;
      var pane = $('.itr-promo__panel', p); if (pane) releaseFocus(pane);
    });
    closeCart(); closeNav(); closeSearch(); lockScroll(false);
  });

  /* ─── Per-page init ─── */

  /* ─── Welcome promo wheel ─── */
  function initPromo() {
    var root = $('[data-welcome-promo]');
    var replay = $$('[data-promo-replay]');
    if (!root) { replay.forEach(function (b) { b.hidden = true; }); return; }

    var wheel = $('[data-wheel]', root);
    var spinBtn = $('[data-wheel-spin]', root);
    var steps = {
      wheel: $('[data-promo-step="wheel"]', root),
      claim: $('[data-promo-step="claim"]', root),
      done: $('[data-promo-step="done"]', root)
    };
    var labels = $$('[data-wheel-label]', root);
    var pips = $$('[data-wheel-pip]', root);
    var seg = 360 / Math.max(1, labels.length);
    var angle = 0, spinning = false, prize = null;

    /* Wedge 0 is centred under the top pointer via the gradient's -45deg origin,
       so the wheel element itself stays at 0deg and labels start upright. */
    var stops = labels.map(function (el, i) {
      var colors = ['#39b54a', '#006837', '#12a353', '#064a29'];
      return colors[i % 4] + ' ' + (i * seg) + 'deg ' + ((i + 1) * seg) + 'deg';
    }).join(',');
    if (wheel) wheel.style.background = 'conic-gradient(from -' + (seg / 2) + 'deg, ' + stops + ')';

    function place() {
      labels.forEach(function (el, i) {
        /* Cancel the wedge angle AND the wheel's live rotation so text stays level. */
        el.style.transform = 'rotate(' + (i * seg) + 'deg) translateY(-84px) rotate(' + (-(i * seg) - angle) + 'deg)';
      });
      pips.forEach(function (el, i) {
        el.style.transform = 'rotate(' + (i * seg - seg / 2) + 'deg) translateY(-118px)';
      });
    }
    place();

    function show(name) {
      Object.keys(steps).forEach(function (k) { if (steps[k]) steps[k].hidden = k !== name; });
    }
    function open() { root.hidden = false; lockScroll(true); var p = $('.itr-promo__panel', root); if (p) { p.focus(); trapFocus(p); } }
    function close() {
      root.hidden = true; lockScroll(false);
      var p = $('.itr-promo__panel', root); if (p) releaseFocus(p);
      try { sessionStorage.setItem('itr-promo-seen', '1'); } catch (e) {}
    }

    if (spinBtn) spinBtn.addEventListener('click', function () {
      if (spinning || prize) return;
      spinning = true;
      spinBtn.disabled = true;
      spinBtn.textContent = 'Spinning…';
      var pick = Math.floor(Math.random() * labels.length);
      var smooth = d.documentElement.classList.contains('itr-anim-ready');
      angle = smooth ? 360 * 6 + (360 - pick * seg) : 360 - pick * seg;
      if (wheel) wheel.style.transform = 'rotate(' + angle + 'deg)';
      place();
      var reveal = function () {
        prize = labels[pick].textContent.replace(/\s+/g, ' ').trim();
        var nameEl = $('[data-prize-name]', root), echo = $('[data-prize-echo]', root), field = $('[data-prize-field]', root);
        if (nameEl) nameEl.textContent = prize;
        if (echo) echo.textContent = prize;
        if (field) field.value = prize;
        spinning = false;
        show('claim');
      };
      smooth ? setTimeout(reveal, 5300) : reveal();
    });

    /* Email step: validate here, then let Shopify's customer form post for real. */
    var form = $('[data-promo-form]', root);
    if (form) form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      var err = $('[data-promo-err]', root);
      var val = input ? input.value.trim() : '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) {
        e.preventDefault();
        if (err) { err.textContent = 'Enter a valid email so we can send your code.'; err.hidden = false; }
        if (input) input.classList.add('is-bad');
        return;
      }
      var echo = $('[data-email-echo]', root);
      if (echo) echo.textContent = val;
      try { sessionStorage.setItem('itr-promo-claimed', '1'); } catch (e2) {}
    });

    $$('[data-promo-close]', root).forEach(function (b) { b.addEventListener('click', function (ev) { ev.preventDefault(); close(); }); });
    replay.forEach(function (b) { b.addEventListener('click', function () { show(prize ? 'done' : 'wheel'); open(); }); });

    /* Shopify redirects back with ?customer_posted=true after the form posts. */
    if (/customer_posted=true/.test(window.location.search)) { show('done'); open(); return; }

    var seen = null;
    try { seen = sessionStorage.getItem('itr-promo-seen'); } catch (e) {}
    if (!seen) setTimeout(open, 1200);
  }


  function init() {
    initPromo();
    requestAnimationFrame(function () { d.documentElement.classList.add('itr-anim-ready'); });
    /* Featured-deal panels: hover on pointer devices, tap elsewhere */
    var panels = $$('.itr-panel');
    function activate(p) {
      panels.forEach(function (x) { x.classList.remove('is-active'); });
      p.classList.add('is-active');
    }
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover) and (min-width: 861px)').matches) activate(p);
      });
      p.addEventListener('click', function (e) {
        if (!e.target.closest('a,button')) activate(p);
      });
    });

    /* Collection carousels */
    $$('[data-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-carousel-track]');
      if (!track) return;
      var prev = car.querySelector('[data-carousel-prev]');
      var next = car.querySelector('[data-carousel-next]');
      function step() {
        var item = track.querySelector('.itr-carousel__item');
        var w = item ? item.getBoundingClientRect().width + 18 : 280;
        return Math.max(w, Math.floor(track.clientWidth * 0.8 / w) * w);
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function beh() { return d.documentElement.classList.contains('itr-anim-ready') ? 'smooth' : 'auto'; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: beh() }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: beh() }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    /* Featured-deal countdown timers */
    $$('[data-countdown]').forEach(function (el) {
      var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
      function target() {
        var set = el.dataset.ends;
        if (set) {
          var t = new Date(set.replace(' ', 'T')).getTime();
          if (!isNaN(t) && t > Date.now()) return t;
        }
        var mid = new Date(); mid.setHours(24, 0, 0, 0); // rolls over daily
        return mid.getTime();
      }
      function tick() {
        var diff = Math.max(0, target() - Date.now());
        var sec = Math.floor(diff / 1000);
        var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
        if (h) h.textContent = pad(Math.floor(sec / 3600));
        if (m) m.textContent = pad(Math.floor(sec % 3600 / 60));
        if (s) s.textContent = pad(sec % 60);
      }
      tick();
      setInterval(tick, 1000);
    });

    /* Our Process tabs */
    $$('[data-proc]').forEach(function (proc) {
      var tabs = $$('[data-proc-tab]', proc);
      var panels = $$('[data-proc-panel]', proc);
      function show(i) {
        tabs.forEach(function (t) { var on = t.dataset.procTab === i; t.classList.toggle('is-on', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('is-on', p.dataset.procPanel === i); });
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.dataset.procTab); });
        t.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover) and (min-width: 861px)').matches) show(t.dataset.procTab);
        });
      });
    });

    /* Product variant switching — price, availability, media, URL */
    var pdp = $('[data-product-form]');
    if (pdp) initVariants(pdp);

    /* Support ticket form: order number required for returns */
    var ticket = $('[data-ticket-form]');
    if (ticket) {
      var orderInput = ticket.querySelector('[name="contact[order_number]"]');
      var lbl = ticket.querySelector('[data-order-label]');
      var sync = function () {
        var picked = ticket.querySelector('[name="contact[ticket_type]"]:checked');
        var isReturn = picked && picked.value.indexOf('Return') !== -1;
        if (orderInput) { orderInput.required = !!isReturn; }
        if (lbl) lbl.innerHTML = isReturn ? 'Order number <em>*</em>' : 'Order number <span class="itr-field__opt">(optional)</span>';
      };
      $$('[name="contact[ticket_type]"]', ticket).forEach(function (r) { r.addEventListener('change', sync); });
      sync();
    }

    /* Sticky mobile add-to-cart bar shows once the real button scrolls away */
    var atc = $('[data-atc-anchor]');
    var bar = $('[data-atc-bar]');
    if (atc && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -40px 0px' }).observe(atc);
    }

    syncCount();
  }

  /* Update an add-to-cart button without touching its markup (keeps the icon). */
  function setAtc(btn, disabled, text) {
    if (!btn) return;
    btn.disabled = !!disabled;
    var span = btn.querySelector('[data-atc-text]');
    if (span) span.textContent = text; else btn.textContent = text;
  }

  function initVariants(form) {
    var data = $('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idField = form.querySelector('[name="id"]');
    var submit = form.querySelector('[type="submit"]');

    function selected() {
      return $$('[data-option-index]', form).map(function (el) {
        if (el.type === 'radio') return null;
        return el.value;
      }).filter(function (v) { return v !== null; });
    }
    function currentOptions() {
      var out = [];
      $$('[data-option-group]', form).forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) out.push(checked.value);
        else {
          var sel = group.querySelector('select');
          if (sel) out.push(sel.value);
        }
      });
      return out;
    }
    function update() {
      var opts = currentOptions();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) { match = v; break; }
      }
      if (!match) { setAtc(submit, true, 'Unavailable'); return; }
      if (idField) idField.value = match.id;
      setAtc(submit, !match.available, match.available ? 'Add to cart' : 'Sold out');
      var priceEl = $('[data-variant-price]');
      if (priceEl) priceEl.innerHTML = match.price_html;
      var metaEl = $('[data-variant-meta]');
      if (metaEl) {
        var bits = '';
        if (match.sku) bits += '<span class="itr-pdp__sku">SKU <b>' + match.sku + '</b></span>';
        var low = parseInt(metaEl.dataset.low || '5', 10);
        if (!match.available) bits += '<span class="itr-pdp__stock itr-pdp__stock--out"><i></i>Out of stock</span>';
        else if (!match.track) bits += '<span class="itr-pdp__stock"><i></i>In stock</span>';
        else if (match.qty > 0 && match.qty <= low) bits += '<span class="itr-pdp__stock itr-pdp__stock--low"><i></i>Only ' + match.qty + ' left</span>';
        else if (match.qty > 0) bits += '<span class="itr-pdp__stock"><i></i>' + match.qty + ' in stock</span>';
        else bits += '<span class="itr-pdp__stock"><i></i>Available to order</span>';
        metaEl.innerHTML = bits;
      }
      var img = $('[data-pdp-image]');
      if (img && match.image) { img.src = match.image; img.srcset = ''; }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
